// import { useState, useEffect } from "react";
// import api from "../api";
// import EmployeeLayout from "../components/EmployeeLayout";

// const DailySheet = () => {
//   const today = new Date().toISOString().slice(0, 10);

//   const [entries, setEntries] = useState([]);
//   const [currentEntry, setCurrentEntry] = useState(null);
//   const [initialLoadDone, setInitialLoadDone] = useState(false);
//   const [userTouchedForm, setUserTouchedForm] = useState(false);

//   // Form State
//   const [form, setForm] = useState({
//     entry_date: today,
//     status: "Assignment",
//     hours: "",
//     comment: "",
//   });

//   const isLocked =
//     currentEntry &&
//     currentEntry.manager_status &&
//     currentEntry.manager_status !== "PENDING";

//   // Load recent entries (table)
//   useEffect(() => {
//     loadEntries();
//   }, []);

//   const loadEntries = async () => {
//     try {
//       const res = await api.get("/daily-sheet");
//       setEntries(res.data || []);
//     } catch (err) {
//       console.error("Error loading daily entries", err);
//     }
//   };

//   // Load entry for selected date — but not on first page load
//   useEffect(() => {
//     if (!initialLoadDone) {
//       setInitialLoadDone(true);
//       return;
//     }

//     setUserTouchedForm(false); // user changed date manually
//     loadEntryForSelectedDate();
//   }, [form.entry_date]);

//   const loadEntryForSelectedDate = async () => {
//     try {
//       const res = await api.get("/daily-sheet", {
//         params: { date: form.entry_date },
//       });

//       if (res.data && res.data.length > 0) {
//         const row = res.data[0];
//         setCurrentEntry(row);

//         // Load into form ONLY if user has not started typing
//         if (!userTouchedForm) {
//           setForm((prev) => ({
//             ...prev,
//             status: row.status,
//             hours: row.hours || "",
//             comment: row.comment || "",
//           }));
//         }
//       } else {
//         // No entry for that date
//         setCurrentEntry(null);

//         if (!userTouchedForm) {
//           setForm((prev) => ({
//             ...prev,
//             status: "Assignment",
//             hours: "",
//             comment: "",
//           }));
//         }
//       }
//     } catch (err) {
//       console.error("Error loading entry for date", err);
//     }
//   };

//   // ------------------------------------
//   //  HANDLE CHANGE with SMART RULES
//   // ------------------------------------
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setUserTouchedForm(true);

//     const selectedDate = new Date(
//       name === "entry_date" ? value : form.entry_date
//     );
//     const todayDate = new Date(today);

//     // ① Status Change Logic
//     if (name === "status") {
//       if (value === "Leave") {
//         // Leave allowed only on FUTURE dates
//         if (selectedDate <= todayDate) {
//           const tomorrow = new Date();
//           tomorrow.setDate(tomorrow.getDate() + 1);
//           const nextDate = tomorrow.toISOString().slice(0, 10);

//           setForm((f) => ({
//             ...f,
//             status: value,
//             entry_date: nextDate,
//           }));
//           return;
//         }
//       } else {
//         // Other statuses allowed only for TODAY or PAST
//         if (selectedDate > todayDate) {
//           setForm((f) => ({
//             ...f,
//             status: value,
//             entry_date: today,
//           }));
//           return;
//         }
//       }
//     }

//     // ② Date Change Logic
//     if (name === "entry_date") {
//       const selected = new Date(value);

//       if (form.status === "Leave") {
//         // Leave must be future date
//         if (selected <= todayDate) {
//           const tomorrow = new Date();
//           tomorrow.setDate(tomorrow.getDate() + 1);
//           const nextDate = tomorrow.toISOString().slice(0, 10);

//           setForm((f) => ({
//             ...f,
//             entry_date: nextDate,
//           }));
//           return;
//         }
//       } else {
//         // Other statuses must be ≤ today
//         if (selected > todayDate) {
//           setForm((f) => ({
//             ...f,
//             entry_date: today,
//           }));
//           return;
//         }
//       }
//     }

//     // Default state update
//     setForm((f) => ({ ...f, [name]: value }));
//   };

//   // ------------------------------------
//   // SAVE ENTRY
//   // ------------------------------------
//   const handleSave = async (e) => {
//     e.preventDefault();

//     if (isLocked) {
//       alert("This entry has been reviewed. You cannot edit it.");
//       return;
//     }

//     if (!form.entry_date || !form.comment.trim()) {
//       alert("Date and comment are required.");
//       return;
//     }

//     try {
//       await api.post("/daily-sheet", form);
//       await loadEntries();
//       alert("Saved successfully!");

//       // Reset form after save
//       setForm({
//         entry_date: today,
//         status: "Assignment",
//         hours: "",
//         comment: "",
//       });

//       setCurrentEntry(null);
//       setInitialLoadDone(false);
//       setUserTouchedForm(false);
//     } catch (err) {
//       alert(err?.response?.data?.message || "Error saving entry");
//     }
//   };

//   const formatDate = (iso) => {
//     const d = new Date(iso);
//     return d.toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   return (
//     <EmployeeLayout>
//       <div className="daily-sheet-header">
//         <h2 className="daily-title">Daily Sheet & Notes</h2>
//         <p className="daily-subtitle">
//           Submit your daily work log, assignments, WFH updates, leave requests and notes.
//         </p>
//       </div>

//       {isLocked && (
//         <div className="daily-lock-banner">
//           This entry has been reviewed by your manager and cannot be edited.
//         </div>
//       )}

//       {/* Form */}
//       <form className="daily-form" onSubmit={handleSave}>
//         <div className="daily-form-grid">
//           {/* DATE */}
//           <div className="field">
//             <label className="field-label">Date</label>
//             <input
//               type="date"
//               className="field-input"
//               name="entry_date"
//               value={form.entry_date}
//               onChange={handleChange}
//               min={form.status === "Leave" ? today : undefined}
//               max={form.status === "Leave" ? undefined : today}
//               disabled={isLocked}
//             />
//           </div>

//           {/* STATUS */}
//           <div className="field">
//             <label className="field-label">Status</label>
//             <select
//               className="field-input"
//               name="status"
//               value={form.status}
//               onChange={handleChange}
//               disabled={isLocked}
//             >
//               <option value="Assignment">Assignment</option>
//               <option value="WFH">WFH</option>
//               <option value="Leave">Leave</option>
//               <option value="Half Day">Half Day</option>
//               <option value="Vacation">Vacation</option>
//             </select>
//           </div>

//           {/* HOURS */}
//           <div className="field">
//             <label className="field-label">Hours (optional)</label>
//             <input
//               type="number"
//               className="field-input"
//               name="hours"
//               step="0.5"
//               min="0"
//               value={form.hours}
//               onChange={handleChange}
//               disabled={isLocked}
//               placeholder="e.g. 8.0"
//             />
//           </div>
//         </div>

//         {/* COMMENT */}
//         <div className="field">
//           <label className="field-label">Daily Comment / Summary *</label>
//           <textarea
//             className="field-input daily-textarea"
//             name="comment"
//             value={form.comment}
//             onChange={handleChange}
//             disabled={isLocked}
//             placeholder="Example: Completed payroll module, fixed login issues, updated UI components."
//           />
//         </div>

//         {/* ACTIONS */}
//         <div className="daily-actions">
//           <button
//             className="btn-primary-large"
//             type="submit"
//             disabled={isLocked}
//           >
//             {isLocked ? "Reviewed - Locked" : "Save Entry"}
//           </button>
//         </div>
//       </form>

//       {/* ENTRIES TABLE */}
//       <div className="daily-table-wrapper">
//         <h3 className="daily-table-title">Recent Entries</h3>

//         {entries.length === 0 ? (
//           <p className="daily-empty">No entries yet.</p>
//         ) : (
//           <table className="emp-table">
//             <thead>
//               <tr>
//                 <th>Date</th>
//                 <th>Status</th>
//                 <th>Hours</th>
//                 <th>Comment</th>
//                 <th>Manager Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {entries.map((e) => (
//                 <tr key={e.entry_date}>
//                   <td>{formatDate(e.entry_date)}</td>
//                   <td>{e.status}</td>
//                   <td>{e.hours || "-"}</td>
//                   <td>{e.comment}</td>
//                   <td>{e.manager_status || "PENDING"}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </div>
//     </EmployeeLayout>
//   );
// };

// export default DailySheet;







// import { useState, useEffect } from "react";
// import api from "../api";
// import EmployeeLayout from "../components/EmployeeLayout";

// const DailySheet = () => {
//   const today = new Date().toISOString().slice(0, 10);
//   const [entries, setEntries] = useState([]);
//   const [editDate, setEditDate] = useState(null); // currently editing row
//   const [editForm, setEditForm] = useState({
//     status: "",
//     hours: "",
//     comment: "",
//   });

//   useEffect(() => {
//     loadEntries();
//   }, []);

//   const loadEntries = async () => {
//     try {
//       const res = await api.get("/daily-sheet");
//       setEntries(res.data || []);
//     } catch (err) {
//       console.error("Error loading entries", err);
//     }
//   };

//   // -------------------------------
//   // START EDITING A ROW
//   // -------------------------------
//   const handleEdit = (row) => {
//     if (row.manager_status !== "PENDING") {
//       alert("You cannot edit this entry. Manager already reviewed it.");
//       return;
//     }

//     setEditDate(row.entry_date);
//     setEditForm({
//       status: row.status,
//       hours: row.hours || "",
//       comment: row.comment || "",
//     });
//   };

//   // -------------------------------
//   // CANCEL EDIT
//   // -------------------------------
//   const cancelEdit = () => {
//     setEditDate(null);
//     setEditForm({ status: "", hours: "", comment: "" });
//   };

//   // -------------------------------
//   // SAVE CHANGES
//   // -------------------------------
//   const saveEdit = async () => {
//     try {
//       await api.put(`/daily-sheet/${editDate}`, editForm);
//       await loadEntries();
//       cancelEdit();
//     } catch (err) {
//       alert(err.response?.data?.message || "Error updating entry");
//     }
//   };

//   const formatDate = (iso) => {
//     const d = new Date(iso);
//     return d.toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   // -------------------------------
//   // DATE RULE CHECKS FOR STATUS
//   // -------------------------------
//   const isFuture = (date) => new Date(date) > new Date(today);
//   const isPastOrToday = (date) => new Date(date) <= new Date(today);

//   return (
//     <EmployeeLayout>
//       <div className="daily-sheet-header">
//         <h2 className="daily-title">Daily Sheet & Notes</h2>
//         <p className="daily-subtitle">
//           Update your daily work log. You can edit only entries that are not yet reviewed.
//         </p>
//       </div>

//       {/* TABLE */}
//       <div className="daily-table-wrapper">
//         <h3 className="daily-table-title">Entries</h3>

//         {entries.length === 0 ? (
//           <p className="daily-empty">No entries yet.</p>
//         ) : (
//           <table className="emp-table">
//             <thead>
//               <tr>
//                 <th>Date</th>
//                 <th>Status</th>
//                 <th>Hours</th>
//                 <th>Comment</th>
//                 <th>Manager Status</th>
//                 <th>Action</th>
//               </tr>
//             </thead>

//             <tbody>
//               {entries.map((e) => {
//                 const isEditing = editDate === e.entry_date;
//                 const dateIsFuture = isFuture(e.entry_date);
//                 const dateIsPastOrToday = isPastOrToday(e.entry_date);

//                 return (
//                   <tr key={e.entry_date}>
//                     {/* DATE */}
//                     <td>{formatDate(e.entry_date)}</td>

//                     {/* STATUS */}
//                     <td>
//                       {isEditing ? (
//                         <select
//                           className="inline-input"
//                           value={editForm.status}
//                           onChange={(ev) =>
//                             setEditForm((f) => ({
//                               ...f,
//                               status: ev.target.value,
//                             }))
//                           }
//                         >
//                           {/* Leave allowed only for future dates */}
//                           <option
//                             value="Leave"
//                             disabled={!dateIsFuture}
//                           >
//                             Leave
//                           </option>

//                           {/* Other statuses allowed only past/today */}
//                           <option
//                             value="Assignment"
//                             disabled={!dateIsPastOrToday}
//                           >
//                             Assignment
//                           </option>
//                           <option
//                             value="WFH"
//                             disabled={!dateIsPastOrToday}
//                           >
//                             WFH
//                           </option>
//                           <option
//                             value="Half Day"
//                             disabled={!dateIsPastOrToday}
//                           >
//                             Half Day
//                           </option>
//                           <option
//                             value="Vacation"
//                             disabled={!dateIsPastOrToday}
//                           >
//                             Vacation
//                           </option>
//                         </select>
//                       ) : (
//                         e.status
//                       )}
//                     </td>

//                     {/* HOURS */}
//                     <td>
//                       {isEditing ? (
//                         <input
//                           className="inline-input"
//                           type="number"
//                           step="0.5"
//                           min="0"
//                           value={editForm.hours}
//                           onChange={(ev) =>
//                             setEditForm((f) => ({
//                               ...f,
//                               hours: ev.target.value,
//                             }))
//                           }
//                         />
//                       ) : (
//                         e.hours || "-"
//                       )}
//                     </td>

//                     {/* COMMENT */}
//                     <td>
//                       {isEditing ? (
//                         <textarea
//                           className="inline-textarea"
//                           value={editForm.comment}
//                           onChange={(ev) =>
//                             setEditForm((f) => ({
//                               ...f,
//                               comment: ev.target.value,
//                             }))
//                           }
//                         />
//                       ) : (
//                         e.comment
//                       )}
//                     </td>

//                     {/* MANAGER STATUS */}
//                     <td>{e.manager_status}</td>

//                     {/* ACTION */}
//                     <td>
//                       {isEditing ? (
//                         <>
//                           <button className="btn-small" onClick={saveEdit}>
//                             Save
//                           </button>
//                           <button
//                             className="btn-small btn-secondary"
//                             onClick={cancelEdit}
//                           >
//                             Cancel
//                           </button>
//                         </>
//                       ) : e.manager_status === "PENDING" ? (
//                         <button
//                           className="btn-small"
//                           onClick={() => handleEdit(e)}
//                         >
//                           Edit
//                         </button>
//                       ) : (
//                         "-"
//                       )}
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         )}
//       </div>
//     </EmployeeLayout>
//   );
// };

// export default DailySheet;







import { useState, useEffect, useRef } from "react";
import api from "../api";
import EmployeeLayout from "../components/EmployeeLayout";

const DailySheet = () => {
  const today = new Date().toISOString().slice(0, 10);

  const [entries, setEntries] = useState([]);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [initialLoadDone, setInitialLoadDone] = useState(false);
  const [userTouchedForm, setUserTouchedForm] = useState(false);
  const [page, setPage] = useState(1);
  const pageSize = 5;
  const todayObj = new Date();
  const month = todayObj.getMonth(); // 0-based
  const year = todayObj.getFullYear();

  // Inline edit state
  const [editingDate, setEditingDate] = useState(null);
  const [editForm, setEditForm] = useState({
    status: "",
    hours: "",
    comment: "",
  });

  // Form State - Add New Entry
  const [form, setForm] = useState({
    entry_date: "",
    status: "Assignment",
    hours: "8.0",
    comment: "",
  });
  const alertRef = useRef({ msg: "", until: 0 });

  const showAlert = (msg) => {
    const now = Date.now();
    if (alertRef.current.msg === msg && now < alertRef.current.until) return;
    alertRef.current = { msg, until: now + 2000 };
    alert(msg);
  };

  const isLocked =
    currentEntry &&
    currentEntry.manager_status &&
    currentEntry.manager_status !== "PENDING";

  // Load entries initially
  useEffect(() => {
    loadEntries();
  }, []);

  const loadEntries = async () => {
    try {
      const res = await api.get("/daily-sheet");
      const list = res.data || [];
      setEntries(list);
      setPage(1);

    } catch (err) {
      console.error("Error loading daily entries", err);
    }
  };

  // Load entry for selected date — but not on first page load
  useEffect(() => {
    if (!initialLoadDone) {
      setInitialLoadDone(true);
      return;
    }

    setUserTouchedForm(false); // user changed date manually
    loadEntryForSelectedDate();
  }, [form.entry_date]);

  const loadEntryForSelectedDate = async () => {
    try {
      const res = await api.get("/daily-sheet", {
        params: { date: form.entry_date },
      });

      // If entry exists for selected date
      if (res.data && res.data.length > 0 ) {
        showAlert("An entry already exists for this date. Please choose another date.");

        // Reset date back to today
        setForm((f) => ({ ...f, entry_date: "" }));


        setCurrentEntry(null);
        setUserTouchedForm(false);
        return;
      }

      // If NO entry for selected date → allow new form
      setCurrentEntry(null);

      if (!userTouchedForm) {
        setForm((prev) => ({
          ...prev,
          status: "Assignment",
          hours: "8.0",
          comment: "",
          entry_date: ""
        }));
      }
    } catch (err) {
      console.error("Error loading entry for date", err);
    }
  };

  const handleChange = (e) => {
  const { name, value } = e.target;
  setUserTouchedForm(true);

  const selectedDate = new Date(name === "entry_date" ? value : form.entry_date);
  selectedDate.setHours(0, 0, 0, 0);
  const todayDate = new Date();
  todayDate.setHours(0, 0, 0, 0);

  const diffDays = Math.floor((todayDate - selectedDate) / (1000 * 60 * 60 * 24));

  if (name === "status") {
    if (value === "Leave") {
      // Leave allowed for today and future
      if (selectedDate < todayDate) {
        const todayStr = todayDate.toISOString().slice(0, 10);
        setForm((f) => ({ ...f, status: value, entry_date: todayStr }));
        return;
      }
    } else {
      // Non-leave allowed only for last 7 days (including today)
      if (selectedDate > todayDate || diffDays > 6) {
        const todayStr = todayDate.toISOString().slice(0, 10);
        setForm((f) => ({ ...f, status: value, entry_date: todayStr }));
        return;
      }
    }
  }

  if (name === "entry_date") {
    if (form.status === "Leave") {
      if (selectedDate < todayDate) {
        const todayStr = todayDate.toISOString().slice(0, 10);
        showAlert("Leave can be applied only for today or future dates");
        setForm((f) => ({ ...f, entry_date: todayStr }));
        return;
      }
    } else {
      // Non-leave
      if (selectedDate > todayDate || diffDays > 6) {
        const todayStr = todayDate.toISOString().slice(0, 10);
        showAlert("For Assignment/WFH/Half Day/Vacation, you can fill only the last 7 days (including today)");
        setForm((f) => ({ ...f, entry_date: "" }));
        return;
      }
    }
  }

  setForm((f) => ({ ...f, [name]: value }));
};


  // SMART FORM CHANGE
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setUserTouchedForm(true);

  //   const selectedDate = new Date(
  //     name === "entry_date" ? value : form.entry_date
  //   );
  //   const todayDate = new Date(today);

  //   // Status Change
  //   if (name === "status") {
  //     if (value === "Leave" && selectedDate <= todayDate) {
  //       const tomorrow = new Date();
  //       tomorrow.setDate(tomorrow.getDate() + 1);

  //       setForm((f) => ({
  //         ...f,
  //         status: value,
  //         entry_date: tomorrow.toISOString().slice(0, 10),
  //       }));
  //       return;
  //     }

  //     if (value !== "Leave" && selectedDate > todayDate) {
  //       setForm((f) => ({
  //         ...f,
  //         status: value,
  //         entry_date: "",
  //       }));
  //       return;
  //     }
  //   }

  //   // Date Change
  //   if (name === "entry_date") {
  //     if (form.status === "Leave") {
  //       if (selectedDate <= todayDate) {
  //         const tomorrow = new Date();
  //         tomorrow.setDate(tomorrow.getDate() + 1);

  //         setForm((f) => ({
  //           ...f,
  //           entry_date: tomorrow.toISOString().slice(0, 10),
  //         }));
  //         return;
  //       }
  //     } else {
  //       if (selectedDate > todayDate) {
  //         setForm((f) => ({
  //           ...f,
  //           entry_date: "",
  //         }));
  //         return;
  //       }
  //     }
  //   }

  //   setForm((f) => ({ ...f, [name]: value }));
  // };

  // SAVE ENTRY
  const handleSave = async (e) => {
    e.preventDefault();

    if (isLocked) {
      alert("This entry has been reviewed. You cannot edit it.");
      return;
    }

    if (!form.entry_date || !form.comment.trim()) {
      alert("Date and comment are required.");
      return;
    }

    try {
      
      await api.post("/daily-sheet", form);
      await loadEntries();
      alert("Saved successfully!");

      setForm({
        entry_date: "",
        status: "Assignment",
        hours: "8.0",
        comment: "",
      });

      setCurrentEntry(null);
      setInitialLoadDone(false);
      setUserTouchedForm(false);
    } catch (err) {
      alert(err?.response?.data?.message || "Error saving entry");
    }
  };

  // Inline Edit Actions -------------------------
  const startEdit = (row) => {
    setEditingDate(row.entry_date);
    setEditForm({
      status: row.status,
      hours: row.hours || "",
      comment: row.comment || "",
    });
  };

  const cancelEdit = () => {
    setEditingDate(null);
  };

  const handleInlineChange = (e) => {
    const { name, value } = e.target;
    const selectedDate = new Date(editingDate);
    selectedDate.setHours(0, 0, 0, 0);
    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);
    const diffDays = Math.floor((todayDate - selectedDate) / (1000 * 60 * 60 * 24));

    if (name === "status") {
      if (value === "Leave") {
        // allow today or future
        if (selectedDate < todayDate) {
          showAlert("Leave can be applied only for today or future dates");
          return;
        }
      } else {
        // non-leave: only last 7 days including today
        if (selectedDate > todayDate || diffDays > 6) {
          showAlert("Assignment/WFH/HalfDay/Vacation only for last 7 days");
          return;
        }
      }
    }

    setEditForm((f) => ({ ...f, [name]: value }));
  };

  const saveInlineEdit = async () => {
    try {
      const normalizedDate = new Date(editingDate).toISOString().slice(0, 10);
      
      await api.put("/daily-sheet", {
        entry_date: normalizedDate,
        ...editForm,
      });

      await loadEntries();
      setEditingDate(null);
    } catch (err) {
      console.log(err);
      
      alert("Error updating entry");
    }
  };

  // Format date for display
  const formatDate = (iso) => {
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const totalPages = Math.max(1, Math.ceil((entries || []).length / pageSize));
  const visibleEntries = (entries || []).slice(
    (page - 1) * pageSize,
    page * pageSize
  );

  // Calendar helpers
  const startOfMonth = new Date(year, month, 1);
  const startDay = startOfMonth.getDay(); // 0 Sunday
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const filledSet = new Set((entries || []).map((e) => (e.entry_date || "").slice(0, 10)));
  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const monthLabel = startOfMonth.toLocaleDateString("en-IN", {
    month: "long",
    year: "numeric",
  });

  return (
    <EmployeeLayout>
      <div className="daily-sheet-header">
        <h2 className="daily-title">Daily Sheet & Notes</h2>
        <p className="daily-subtitle">
          Submit your daily work log, assignments, WFH updates, leave requests and notes.
        </p>
      </div>

      {/* Month Calendar */}
      <div className="card calendar-card">
        <div className="card-header">
          <h3>{monthLabel}</h3>
          <p className="text-muted">Green = filled, Red = missing entry</p>
        </div>
        <div className="calendar-scroll">
          <div className="calendar-grid">
            {weekdays.map((d) => (
              <div key={d} className="calendar-day header">
                {d}
              </div>
            ))}
            {Array.from({ length: startDay }).map((_, idx) => (
              <div key={`empty-${idx}`} className="calendar-day empty-slot" />
            ))}
            {Array.from({ length: daysInMonth }).map((_, idx) => {
              const day = idx + 1;
              const dateStr = `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(
                2,
                "0"
              )}`;
              const hasEntry = filledSet.has(dateStr);
              const isToday = dateStr === today;
              return (
                <div
                  key={dateStr}
                  className={`calendar-day ${hasEntry ? "filled" : "missing"} ${
                    isToday ? "today" : ""
                  }`}
                >
                  <span className="day-number">{day}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* ADD NEW ENTRY */}
      <form className="daily-form" onSubmit={handleSave}>
        <div className="daily-form-grid">
          <div className="field">
            <label className="field-label">Date</label>
            <input
              type="date"
              className="field-input"
              name="entry_date"
              value={form.entry_date}
              onChange={handleChange}
              min={form.status === "Leave" ? today : undefined}
              max={form.status !== "Leave" ? today : undefined}
            />
          </div>

          <div className="field">
            <label className="field-label">Status</label>
            <select
              className="field-input"
              name="status"
              value={form.status}
              onChange={handleChange}
            >
              <option value="Assignment">Assignment</option>
              <option value="WFH">WFH</option>
              <option value="Leave">Leave</option>
              <option value="Half Day">Half Day</option>
              <option value="Vacation">Vacation</option>
            </select>
          </div>

          <div className="field">
            <label className="field-label">Hours</label>
            <input
              type="number"
              className="field-input"
              name="hours"
              step="0.5"
              min="0"
              value={form.hours}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="field">
          <label className="field-label">Daily Comment / Summary *</label>
          <textarea
            className="field-input daily-textarea"
            name="comment"
            value={form.comment}
            onChange={handleChange}
          />
        </div>

        <div className="daily-actions">
          <button className="btn-primary-large" type="submit">
            Save Entry
          </button>
        </div>
      </form>

      {/* TABLE */}
      <div className="daily-table-wrapper">
        <h3 className="daily-table-title">Recent Entries</h3>

        {entries.length === 0 ? (
          <p className="daily-empty">No entries yet.</p>
        ) : (
          <div className="table-scroll">
          <table className="emp-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Status</th>
                <th>Hours</th>
                <th>Comment</th>
                <th>Manager Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {visibleEntries.map((e) => {
                const isEditing = editingDate === e.entry_date;
                const reviewed = e.manager_status !== "PENDING";

                return (
                  <tr key={e.entry_date} className={isEditing ? "editing" : ""}>
                    <td>{formatDate(e.entry_date)}</td>

                    {/* STATUS CELL */}
                    <td>
                      {isEditing ? (
                        <select
                          name="status"
                          value={editForm.status}
                          onChange={handleInlineChange}
                        >
                          <option value="Assignment">Assignment</option>
                          <option value="WFH">WFH</option>
                          <option value="Leave">Leave</option>
                          <option value="Half Day">Half Day</option>
                          <option value="Vacation">Vacation</option>
                        </select>
                      ) : (
                        e.status
                      )}
                    </td>

                    {/* HOURS CELL */}
                    <td>
                      {isEditing ? (
                        <input
                          type="number"
                          name="hours"
                          step="0.5"
                          min="0"
                          value={editForm.hours}
                          onChange={handleInlineChange}
                        />
                      ) : (
                        e.hours || "-"
                      )}
                    </td>

                    {/* COMMENT CELL */}
                    <td style={{ whiteSpace: "pre-wrap" }}>
                      {isEditing ? (
                        <textarea
                          name="comment"
                          value={editForm.comment}
                          onChange={handleInlineChange}
                        />
                      ) : (
                        e.comment
                      )}
                    </td>

                    <td>{e.manager_status || "PENDING"}</td>

                    <td>
                      {!reviewed && !isEditing && (
                        <button
                          className="btn-small"
                          onClick={() => startEdit(e)}
                        >
                          Edit
                        </button>
                      )}

                      {isEditing && (
                        <>
                          <button
                            className="btn-small"
                            onClick={saveInlineEdit}
                          >
                            Save
                          </button>
                          <button
                            className="btn-secondary btn-small"
                            onClick={cancelEdit}
                            style={{ marginLeft: "6px" }}
                          >
                            Cancel
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          </div>
        )}
      </div>

      {entries.length > 0 && (
        <div className="pagination">
          <button
            className="btn-small"
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page === 1}
          >
            Prev
          </button>
          <span className="pagination-info">
            Page {page} of {totalPages}
          </span>
          <button
            className="btn-small"
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </EmployeeLayout>
  );
};

export default DailySheet;
